
import React from "react"
import { Grid, Paper, Button, TableCell, makeStyles, Table, TableHead, TableRow, Typography } from "@material-ui/core"
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { ListClientes } from "./../../../../src/centraldevida/users_auth/components/listClientes";
import { panelUsersAuthStyle } from "../../users_auth/panelUsersAuthStyle";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Store } from "react-notifications-component";
import { ModalTowButton } from "../../../utils/modals/modalInfoTowButton";
import { ModalChangeRol } from "../../users_auth/components/modals/modalChangeRol";
import { ModalClientes } from "../../users_auth/components/modals/modalClientes";
import { getClientes, updateStatusAuth } from "../../domain/api/ClientesApi"
import TablePagination from '@material-ui/core/TablePagination';
import { useHistory } from 'react-router-dom';
import theme from "../../../app/config/themaConfig";
import { BiSearch } from "react-icons/bi";


const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: '30px',
        marginTop: '30px',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        textAlign: "left", // Align "Clientes" to the left
    },
    TableCell: {
        color: '#0088FE',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        fontSize: '17px',

    },
    title: {
        marginBottom: '30px',
        marginTop: '30px',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        marginLeft: '10%'
    },
    box: {
        marginLeft: '3.5%',
        marginTop: '3%'
    }, searchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end', // Alinea al final (derecha)
        paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
        width: '100%'
    },
    searchInputContainer: {
        display: 'flex',
        borderRadius: '20px 0px 0px 20px',
        height: '32px',
        fontSize: '16px',

    },
    searchInput: {
        border: '1px solid  #b6b7b7',
        borderRadius: '20px 0px 0px 20px',
        padding: '4px 8px',
        height: '100%',
        fontSize: 'inherit',
        outline: 'none',
        flex: 1,
    },
    searchButton: {
        background: '#0088FE',
        color: 'white',
        borderRadius: '0px 50px 50px 0px',
        padding: '8px 16px',
        fontSize: '14px',
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
}));




export default function Clientes() {
    const classes = useStyles()

    const clases = panelUsersAuthStyle()
    const [isOpenModal, setisOpenModal] = useState(false)
    const [isEdit, setisEdit] = useState(false)
    const [dataEdit, setdataEdit] = useState([])
    const [, setEmail] = useState("")
    const [status, setStatus] = useState(true)
    const [listDate, setlistDate] = useState([])
    const [loading, setLoading] = useState(false)
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [busqueda, setBusqueda] = useState("")
    const [page, setPage] = useState(0)
    const [open, setOpen] = useState(false);
    const [totalElements, setTotalElements] = useState("")


    const history = useHistory();


    const filtrar = () => {
        reload(busqueda, 0, rowsPerPage)

    }
    const buscador = (e) => {
        setBusqueda(e.target.value, "esta es la busqueda")

    }

    //cambio de pagina
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
        reload(busqueda, newPage, rowsPerPage)

    };
    //cambio de tamaño
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        reload(busqueda, 0, event.target.value)
        setPage(0)

    };
    // Modal info change rol
    const [isOpenModalChange, setisOpenModalChange] = useState(false)
    const [dateChangeRol, setdateChangeRol] = useState("")
    const [, Setid] = useState("")

    const [isOpenModalRol, setisOpenModalRol] = useState(false)
    const dispath = useDispatch()

    //Modal habilitar inhabilitar
    const [isOpenModalChangeStatus, setisOpenModalChangeStatus] = useState(false)
    const [stateUser, setstateUser] = useState("")

    // Modal handled machine
    const [isOpenModalMachine, setisOpenModalMachine] = useState(false)
    const [id_change_bascula, setid_change_bascula] = useState("")

    // variables multi select machine
    const [lisMachine, setlisMachine] = useState([])
    const [selectMachine, setselectMachine] = useState([])


    // Function to handled machine


    const handledOpenEditModal = (data) => {
        setdataEdit(data)
        setisEdit(true)
        setisOpenModal(true)
    }

    const handledOpenModal = () => {
        setdataEdit([])
        setisEdit(false)
        setisOpenModal(true)
    }

    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
        setTimeout(() => {
            init(busqueda, 0, rowsPerPage)
        }, 1000);
    }

    //listar clientes
    const init = async () => {

        //lista de clientes
        const users = await getClientes(dispath, busqueda, page, rowsPerPage)


        try {

            setlistDate(users.content)
            setTotalElements(users.totalElements)
            setLoading(false)
        } catch {
            setlisMachine([])
            setlistDate([])
            setLoading(false)
        }



    }
    const reload = () => {
        init(busqueda, 0, rowsPerPage)


    }





    const OpenModalInfoChangeRol = (date) => {
        setisOpenModalChange(true)
        setdateChangeRol(date)
    }

    const openModalRol = () => {
        setisOpenModalChange(false)
        setisOpenModalRol(true)
    }

    const openModalMachine = (row) => {
        // asignedBasculaById(row.id)
        setid_change_bascula(row.id)
        setisOpenModalMachine(true)
    }

    const handledOpenModalState = (data) => {
        setstateUser(data)
        setisOpenModalChangeStatus(true)
    }



    const changeStatus = async () => {
        const response = await updateStatusAuth(dispath,stateUser.id)

        try {

            if (response) {
                handledAlert("Actualizado Exitosamente!", `usuario ${stateUser.nombre} actualizadp con exito!`, "success")
                setisOpenModalChangeStatus(false)
            } else {
                handledAlert("Ocurrio un erro!", "Ocurrio un error al cambiar el estado", "danger")
            }

        } catch {
            handledAlert("Ocurrio un erro!", "Error interno", "danger")
        }
    }



    useEffect(async () => {
        init(busqueda, 0, rowsPerPage)

    }, [])

    const primaryColor = theme.palette.primary.main;
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            filtrar();
        }
    };

    return (
        <>
            {isOpenModal && <ModalClientes
                setopenMondal={setisOpenModal}
                rowsPerPage={rowsPerPage}
                busqueda={busqueda}
                isOpen={isOpenModal}
                isEdit={isEdit}
                data={dataEdit}

                reload={init}
            // editUser={EditUser}
            />}

            {isOpenModalChange && <ModalTowButton
                setopenMondal={setisOpenModalChange}
                isOpen={isOpenModalChange}
                reload={init}
                title={"Señor usuario"}
                Messange={"¿Esta seguro de cambiar el Rol para este usuario?"}
                handledAccept={openModalRol}
            />}

            {isOpenModalRol && <ModalChangeRol
                setopenMondal={setisOpenModalRol}
                isOpen={isOpenModalRol}
                reload={init}
                id={dateChangeRol.id}
            />}

            {isOpenModalChangeStatus && <ModalTowButton
                setopenMondal={setisOpenModalChangeStatus}
                isOpen={isOpenModalChangeStatus}
                reload={init}
                title={"Señor usuario"}
                Messange={"¿Esta seguro de cambiar el estado para este cliente?"}
                handledAccept={changeStatus}


            />}

            <Grid item xs={12} >
                <br></br>
                <br></br>

                <MigaPan
                    namePage="Clientes"
                    to="/"
                    namePage2="Administracion"
                    to2="/Administracion"

                >
                    Home
                </MigaPan>
            </Grid>
            <Paper className={classes.paper} >
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} className={classes.searchContainer} >
                            <Typography style={{ marginLeft: '0%', fontSize: '25px', fontWeight: 'bold', textAlign: 'left', marginRight: '55%' }} color='primary'>Clientes</Typography>

                            <Button variant="contained" color="primary" onClick={handledOpenModal}>
                                CREAR CLIENTE
                            </Button>
                            <div className={classes.searchInputContainer}>
                                <input
                                    id="descripcion"
                                    type="buscador"
                                    name="descripcion"
                                    onChange={buscador}
                                    value={busqueda}
                                    onKeyPress={handleKeyPress}
                                    className={classes.searchInput}
                                    placeholder="Buscar"
                                    style={{
                                        border: `1px solid ${theme.palette.primary.main}`,
                                        borderRadius: '20px 0px 0px 20px',
                                        padding: '4px 8px',
                                        fontSize: 'inherit',
                                        outline: 'none',
                                        flex: 1,
                                    }}
                                />
                            </div>
                            <Button onClick={filtrar} className={classes.searchButton}style={{ backgroundColor: theme.palette.primary.main }}>
                                <BiSearch />
                            </Button>
                        </Grid>

                        <Grid item xs={12}>


                            <Table>
                                <TableHead color='primary'>
                                    <TableRow color='primary'>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '3%',color: primaryColor }}>Nombre</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '4%', width: '22%',color: primaryColor }}>Documento</TableCell>
                                        <TableCell className={classes.TableCell} style={{ width: '20%', paddingLeft: '0%',color: primaryColor }}>Telefono</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '19%',color: primaryColor }}>Estado</TableCell>
                                        <TableCell className={classes.TableCell} style={{ paddingLeft: '3%',color: primaryColor }}>Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </Grid>
                        <Grid item xs={12}>
                            <ListClientes
                                rows={listDate}
                                openModalEdit={handledOpenEditModal}
                                classes={clases}
                                totalElement={0}
                                changeRol={OpenModalInfoChangeRol}
                                changeStatus={handledOpenModalState}
                                changeMachine={openModalMachine}
                                isLoanding={loading}

                            />
                        </Grid>
                    </Grid>
                    <Paper className={clases.paper}>

                        <TablePagination
                            component="div"
                            count={totalElements}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Datos por página:"
                            style={{ color: primaryColor }}
                        />
                    </Paper>
                </Grid>
            </Paper>
        </>
    )
}